import React from "react";

import PublicNavigation from "../../components/universal/public-navigation";
import PricesLayout from "../../components/universal/prices-layout";
import PricesContent from "../../components/public/prices";
import PublicFooter from "../../components/universal/public-footer";

import { Helmet } from "react-helmet-async";

const PricesPage = () => {
  return (
    <>
      <Helmet>
        <title>Leadfind - Pris på abonnement</title>
        <meta name="thumbnail" content="https://leadfind.no/showcase.jpg" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Leadfind har kun ett abonnement tilgjengelig som koster 399kr eks moms per måned, for hver enkelt brukertilgang."
        />
        <meta name="author" content="Leadfind" />
        <meta
          name="keywords"
          content="prospecting, salgsverktøy, salg, nye kunder, crm"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://leadfind.no/priser" />
        <meta name="twitter:title" content="Leadfind - Pris på abonnement" />
        <meta
          name="twitter:description"
          content="Leadfind har kun ett abonnement tilgjengelig som koster 399kr eks moms per måned, for hver enkelt brukertilgang."
        />
        <meta name="twitter:image" content="https://leadfind.no/showcase.jpg" />

        <meta property="og:url" content="https://leadfind.no/priser" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Leadfind - Pris på abonnement" />
        <meta
          property="og:description"
          content="Leadfind har kun ett abonnement tilgjengelig som koster 399kr eks moms per måned, for hver enkelt brukertilgang."
        />
        <meta property="og:image" content="https://leadfind.no/showcase.jpg" />
        <link rel="canonical" href="https://leadfind.no/priser" />
      </Helmet>
      <PricesLayout
        Header={() => <PublicNavigation light={true} />}
        Content={() => <PricesContent />}
        Footer={() => <PublicFooter />}
      />
    </>
  );
};

export default PricesPage;
